// extracted by mini-css-extract-plugin
module.exports = {"CustomServiceIcon":"SideBarWrapper_CustomServiceIcon___-W0v"};